import ConversionResultFormatter from './conversionResultFormatter.js';

class LeftRightValueFormatter extends ConversionResultFormatter{
    constructor(negativeSymbol, greaterThanZeroSymbol, zeroSymbol, includeSpace) {
        super();
        
        this.negativeSymbol = negativeSymbol || 'L';
        this.greaterThanZeroSymbol = greaterThanZeroSymbol || 'R';
        this.zeroSymbol = zeroSymbol || '';
        this.includeSpace = includeSpace || true;
    }

    stringify (value, thousandSeparator, decimalSeparator, fractionalDigitsPadding){
        let stringified;
        let numericValue;
        if ( typeof(value) === 'string'){
            stringified = value;
            numericValue = parseFloat(value);
        }
        else{
            stringified = super.stringify(value, thousandSeparator, decimalSeparator, fractionalDigitsPadding);
            numericValue = value;
        }
        
        if (numericValue !== 0){
            if (this.includeSpace){
                stringified += ' ';
            }
            if (stringified[0] && stringified[0] === '-'){
                stringified = stringified.replace('-', '');
                stringified += this.negativeSymbol;
            }
            else if(stringified[0] && stringified[0] === '+'){
                stringified = stringified.replace('+', '');
                stringified += this.greaterThanZeroSymbol;
            }
            else{
                stringified += this.greaterThanZeroSymbol;
            }
        }
        else if(this.zeroSymbol){
            if (this.includeSpace){
                stringified += ' ';
            }
            stringified += this.zeroSymbol;
        }

        return stringified;
    }

    stringifyUnitSymbol(stringified, symbolPrefix, symbolSuffix, unit, unitSymbolIndex){
        if (!stringified){
            return super.stringifyUnitSymbol(stringified, symbolPrefix, symbolSuffix, unit, unitSymbolIndex);
        }

        let suffix = symbolSuffix || '';
        let stringNoExtraSymbol = stringified;

        let lastStringifiedChar = stringified.slice(-1);
        if (lastStringifiedChar === this.negativeSymbol){
            stringNoExtraSymbol = stringified.slice(0, this.includeSpace ? -2: -1);
            if (this.includeSpace){
                suffix += ' ';
            }
            suffix += this.negativeSymbol;
        }
        else if (lastStringifiedChar === this.greaterThanZeroSymbol){
            stringNoExtraSymbol = stringified.slice(0, this.includeSpace ? -2: -1);
            if (this.includeSpace){
                suffix += ' ';
            }
            suffix += this.greaterThanZeroSymbol;

        }
        else if (lastStringifiedChar === this.zeroSymbol){
            stringNoExtraSymbol = stringified.slice(0, this.includeSpace ? -2: -1);
            if (this.includeSpace){
                suffix += ' ';
            }
            suffix += this.zeroSymbol;
        }

        let superStringified = super.stringifyUnitSymbol(stringNoExtraSymbol, symbolPrefix, suffix, unit, unitSymbolIndex);
        // sometimes there is no unit to display, in this case we will have 2 spaces and R/L notation after actual value
        if (suffix && suffix[0] === ' '){
            return superStringified.replace(' ' + suffix, suffix);
        }

        return superStringified;
    }
}

export default LeftRightValueFormatter;